<template>
<div class="compras-table">


 <form @submit.prevent="submit"
            ref="login-form-form"
            novalidate
            :class="{
                'validated': validated
            }">
            <div class="row">
                <div class="col-12">
                    <h3>MOTIVA A TUS AMIGOS A SEGUIR APRENDIENDO</h3>
                    <div class="descripcion_referido">
                        Por cada persona que se régistre y compre un curso.<br>
                        Recibe {{formatCurrency(this.portal.credito_referido)}} en créditos para comprar nuevos cursos en {{this.portal.nombre}}.
                    </div>
                    <br>
                </div>
                <div class="col-lg-6">
                    <div class="form-group">
                        <input type="text"
                            :class="{
                                'form-control': true,
                                'is-invalid': (email_referido=='') && validated,
                                'is-valid': (email_referido!='') && validated
                            }"
                            name="email"
                            id="login-form-email"
                            placeholder="Ingresa direcciones de correos separadas por coma (,)"
                            required
                            autocomplete="off"
                            v-model="email_referido">
                             <div class="invalid-feedback">Este campo no puede ir vacío.</div>
                    </div>
                </div>

            </div>


             <div class="row">
                  <div class="col-lg-4">
                    <button class="btn btn-primary mb-10 text-center">ENVIAR INVITACIONES
                    </button>
                    <div class="perfil-alert"
                    style="font-size: 17px;"
                        v-if="alert.visible">
                        <font-awesome-icon
                            :icon="alert.icon"
                            class="color-white"
                            :class="{
                                spin: alert.iconSpin
                            }" />
                            {{ alert.message }}
                    </div>
                </div>
            </div>

</form>


<hr>


<div class="row">
        <div class="col-12">
            <h3>TAMBIÉN PUEDES COPIAR ESTE LINK Y COMPARTIR COMO QUIERAS</h3>
        </div>
        <div class="col-lg-6">
            <div class="form-group">
                <input type="text"
                    :class="{
                        'form-control': true,
                    }"
                    placeholder="link"
                    readonly
                    disabled
                    autocomplete="off"
                    v-model="urlShared">
            </div>
        </div>
        <div class="col-lg-3" >
            <button class="btn btn-gray mb-10 link-copy"
            style="    background: #5a5a5a;color: #fff;"
            @click="copyUrlShared"
            data-toggle="tooltip"
            title="Link copiado en portapapeles"
            >
            <i class="fas fa-link"></i>
            COPIAR LINK
            </button>
        </div>
        <div class="col-sm-1">
            <a
            :href="'whatsapp://send?text='+urlShared"
            style="color: #28a745;"
            data-toggle="tooltip"
            title="Link copiado en whatsapp"
            >
            <i class="fab fa-whatsapp-square" style="font-size: 48px;"></i>
            </a>
        </div>

        <div class="col-sm-1 margen-social">
            <a
            :href="'http://www.facebook.com/sharer.php?u='+urlShared"
            target="_blank"
            style="color:#3f92ea;"
            data-toggle="tooltip"
            title="Link copiado en facebook"
            >
            <i class="fab fa-facebook-square" style="font-size: 48px;"></i>
            </a>
        </div>
</div>

<div class="row block_static">
<div class="col-lg-12 descripcion_block_static descripcion_block_static"
style="text-align:center">
<div class="row">
    <div class="col-lg-5 credit-right" >
        ACTUALMENTE TIENES :
    </div>
        <div class="col-lg-2" >
    <span
     class="credit"
     style="font-size: 35px;color: rgb(255, 255, 255);position: relative;">
     {{formatCurrency(this.credito)}}</span>
        </div>
    <div class="col-lg-5 credit-left"  >
        PARA COMPARTIR
    </div>
    </div>
    </div>
</div>

<div class="row">
        <div class="col-12" >
            <h3 style="border-bottom:0px">LISTADO DE REFERIDOS</h3>
            <table class="table" style="margin-top:0px" >
                <tr>
                    <th >Referido</th>
                    <th >Email</th>
                    <th >Status</th>
                    <th >Créditos Agregados</th>
                </tr>
                <tr
                    v-for="(tableRow, i) in tableRows"
                    :key="i">
                    <td >
                    {{ tableRow.name }}
                    </td>
                    <td >
                    {{ tableRow.email }}
                    </td>
                    <td >
                    {{ tableRow.status }}
                    </td>
                    <td >
                    {{ formatCurrency(tableRow.credito_agregado) }}
                    </td>
                </tr>

            </table>
        </div>
</div>

</div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import { format, toDate } from "date-fns";
import { es } from "date-fns/esm/locale";
import numeral from "numeral";
import "numeral/locales";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
	faCheck,
	faSpinner,
	faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

numeral.locale("es");
library.add(faCheck, faSpinner, faExclamationTriangle);

export default {
	props: ["referidos"],
	components: {
        FontAwesomeIcon,
        bModal,
        },
	directives: { "b-modal": bModalDirective },
	data() {
		return {
            alert: {
				message: "",
				visible: false,
				icon: "",
				iconSpin: false
			},
            email_referido:"",
            validated:false,
            isSubmitting:false,
            urlShared:"",
            credito:0,
            tableRows:[]
		};
	},
	computed: {
		...mapGetters(["user", "portal", "userId"])
    },
    watch: {
		userId(val, old) {
			if (val != 0 && old == 0) {
				console.log("cargando referidos", val);
				this.formantUrlShared();
			}
		}
	},
	methods: {

        submit() {

			if (this.email_referido != "") {


                this.showAlert({
                    iconSpin: true,
                    message: "Enviando...",
                    icon: "spinner"
                },true);

				this.$api
					.event_klaviyo_referred({
                        url_shared:this.urlShared,
                        list_email:this.email_referido
                        }).then(response => {

                            console.log("RESPUESTA COMPARTIR CODIGO REFERIDO ",response);

                            if (
                                typeof response.data.response !== "undefined" &&
                                response.data.response == "400"
                            ) {

                                this.showAlert({
                                    iconSpin: false,
                                    message: "Error al enviar codigo",
                                    icon: "exclamation-triangle"
                                },true);

                                return false;
                            }

                            this.showAlert({
                                iconSpin: false,
                                message: "Codigo enviado",
                                icon: "check"
                            },true);

                            this.email_referido = "";

                        })
			}else{
                this.validated = true;
            }
        },
		showAlert(options, autoHide) {
			this.alert.visible = true;
			this.alert = Object.assign(this.alert, options);
			if (autoHide)
				setTimeout(() => {
					this.alert.visible = false;
				}, 3000);
		},
        formantUrlShared() {

            if(this.userId > 0 && this.user.referidos){
                var email = this.user.email.split("@");
                var email_to_user = email[0];
                this.credito = this.user.referidos.credito;

                if(email.length){

                    this.urlShared =  "https://"+this.portal.dominio+"/shared/"+email_to_user+"?code_referred="+this.user.referidos.codigo;

                }

                    this.referidos.referidos_users.forEach(val => {
                                this.tableRows.push({
                                   name: (val.user_data_referido.name != null) ? val.user_data_referido.name : 'NA' ,
                                   credito_agregado : val.credito_agregado,
                                   email:val.user_data_referido.email,
                                   status:(val.id_compra != null) ? 'Compra Activa' : 'Registrado'
                                });
                    });


            }
        },
		formatDate(date) {
			return format(toDate(date), "dd-MM-YYYY");
		},
		formatCurrency(amount) {
			return numeral(amount).format("$0,0");
		},
        copyUrlShared (){
            var aux = document.createElement("input");
            aux.setAttribute("value",this.urlShared);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
            console.log("texto copiado")
        }
    }
    ,mounted (){
        this.formantUrlShared();
    }
};
</script>

